/* eslint-disable no-console */
import { useEffect, useState } from 'react'
import { message } from 'antd'
import { AxiosError, AxiosResponse } from 'axios'
import ajustarGrupo from 'Hooks/grupo/ajustarGrupo'
import grupoApiService, { GrupoApi } from 'Services/api/grupo'

import { Grupo } from './types'

interface UseGruposResult {
  fetchGrupos: () => void
  gruposRequest: {
    data: Grupo[]
    hasError: boolean
    isLoading: boolean
  }
}

const useGrupos = (filtro: any = {}): UseGruposResult => {
  const [data, setData] = useState<Grupo[]>([])
  const [hasError, setHasError] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const fetchGrupos = () => {
    setIsLoading(true)

    grupoApiService
      .list(filtro)
      .then((response: AxiosResponse<GrupoApi[]>) => response.data)
      .then((grupos: GrupoApi[]) => grupos.map(ajustarGrupo))
      .then(setData)
      .catch((error: AxiosError | Error | any) => {
        if (error.response && error.response.status === 403) {
          message.error('Usuario não possui permissão para listar o grupo de produtos.')
        } else {
          message.error('Erro ao tentar listar o grupo de produtos.')
        }
        console.log(error)
        setHasError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchGrupos()
  }, [])

  return {
    fetchGrupos,
    gruposRequest: { data, hasError, isLoading }
  }
}

export default useGrupos
